import { render, staticRenderFns } from "./ExtraDataComponent.vue?vue&type=template&id=7f62fae0"
import script from "./ExtraDataComponent.vue?vue&type=script&lang=ts"
export * from "./ExtraDataComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports